"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.6 5.814a1 1 0 0 0-1.536-.845L9.981 7.56v3.618l4.083 2.59a1 1 0 0 0 1.536-.843V5.814Zm-7.019 5.248V7.676H6.093a1.693 1.693 0 1 0 0 3.386h2.488Zm.812-4.786 3.92-2.489C14.913 2.773 17 3.921 17 5.814v7.11c0 1.893-2.088 3.041-3.686 2.027l-3.921-2.489h-.22l-.001 2.199a1.93 1.93 0 0 1-3.86.03l-.038-2.338a3.095 3.095 0 0 1 .82-6.077h3.299Zm-2.717 6.186.035 2.207a.53.53 0 0 0 1.06-.009l.001-2.198H6.676Z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=MegaphoneIcon20.js.map